var map = {
	"./placeholder_belt.png": "1a1a",
	"./placeholder_bottoms.png": "6d9f",
	"./placeholder_hat.png": "c5a9",
	"./placeholder_jacket.png": "944e",
	"./placeholder_necklace.png": "71e4",
	"./placeholder_pendant.png": "980f",
	"./placeholder_primaryWeapon.png": "bf96",
	"./placeholder_ring.png": "1352",
	"./placeholder_secondaryWeapon.png": "7f8a",
	"./placeholder_shoes.png": "de18",
	"./placeholder_tertiaryWeapon.png": "1f8d",
	"./placeholder_wrist.png": "cb34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8749";